import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { PAGE_SIZE } from '../../common/constants';
import { getReturnComment } from '../amazon.services';
import '../amazon.scss';
import { formatDate, isEmptyArray } from '../../common/util.services';
import { Link } from 'react-router-dom';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';

const AmazonReturnComment = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [returnComment, setReturnComment] = useState(rows)
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [orderBy, setOrderBy] = useState('date');
  const [totalRows, setTotalRows] = useState(0);
  const columns: GridColDef[] = [
    { field: 'date', headerName: 'Date', width: 90, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'product', headerName: 'Product', width: 115, filterable: false, sortable: false, editable: false},
    { field: 'color', headerName: 'Color', width: 85, filterable: false, sortable: false, editable: false},
    { field: 'size', headerName: 'Size', width: 90, filterable: false, sortable: false, editable: false, },
    { field: 'unitCount', headerName: 'Pack', width: 55, filterable: false, sortable: false, editable: false,},
    { field: 'orderId', headerName: 'Order Id', width: 165, filterable: false, sortable: false, editable: false,
      renderCell: (params) => { return (<Link to={'https://sellercentral.amazon.com/orders-v3/order/' + params.row.orderId} 
                                        target="_blank">{params.row.orderId}</Link>)}
    },
    { field: 'orderDate', headerName: 'Ord Date', width: 90, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'returnDate', headerName: 'Ret Date', width: 90, filterable: false, sortable: false, editable: false,
      valueFormatter: (value: any) => formatDate(value)
    },
    { field: 'returnReason', headerName: 'Reason', width: 130, filterable: false, sortable: false, editable: false },
    { field: 'returnStatus', headerName: 'Status', width: 130, filterable: false, sortable: false, editable: false },
    { field: 'returnComment', headerName: 'Comment', width: 270, filterable: false, sortable: false, editable: false }
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getReturnComment(props.product, orderBy, page, pageSize, appContext,
        (response: any) => {
          setReturnComment(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [page, pageSize, orderBy]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const handleOrderBy = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOrderBy((event.target as HTMLInputElement).value);
  }

  const getMainPanel = () => {
    return <>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={2}>
          <FormControl>
            <FormLabel sx={{ textAlign: 'center', marginRight: '20px'}} id="orderBy">Sorting</FormLabel>
            <RadioGroup defaultValue="date" name="orderBy" row={true} onChange={handleOrderBy}>
              <FormControlLabel value="default" control={<Radio />} label="Default" />
              <FormControlLabel value="date" control={<Radio />} label="Date" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <IGridComponent title={''} rows={returnComment} columns={columns} loading={loading} maxHeight={450}
          paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
          getRowId={(row: any) => row.rowId} showAction={false}/>
    </>
  }

  return <TitlePanel title='' panelBody={getMainPanel()} />
}

export default AmazonReturnComment;